import { addToCartArgsType } from './types';

export function generateBundleId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Binds co-added lines into one parent-child bundle: every line gets a shared
 * `_bundle_id`, the last line (the main product, by the universal builder
 * convention) also gets `_is_bundle_parent`. Removing the parent later cascades
 * to the children via bundleRemoval.policy. Attrs are prepended so a builder
 * that already supplies note attributes keeps its existing order.
 */
export function tagBundle(lineItems: addToCartArgsType[]): addToCartArgsType[] {
  if (lineItems.length === 0) return lineItems;
  const bundleId = generateBundleId();
  const lastIndex = lineItems.length - 1;
  return lineItems.map((item, i) => {
    const bundleAttrs: Array<Record<string, string>> = [
      { key: '_bundle_id', value: bundleId },
    ];
    if (i === lastIndex) {
      bundleAttrs.push({ key: '_is_bundle_parent', value: '1' });
    }
    return {
      ...item,
      params: {
        ...item.params,
        noteAttributes: [...bundleAttrs, ...(item.params?.noteAttributes ?? [])],
      },
    };
  });
}
